import { render } from "./PaymentReceiptsTable.vue?vue&type=template&id=0dccd4d3&scoped=true"
import script from "./PaymentReceiptsTable.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptsTable.vue?vue&type=script&lang=js"

import "./PaymentReceiptsTable.vue?vue&type=style&index=0&id=0dccd4d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dccd4d3"]])

export default __exports__